import { NgTemplateOutlet } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { FnCallPipe } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { TooltipPosition } from '@core/user-interface-legacy';
import { BadgeComponent, IconComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assigned-locations-info',
  templateUrl: './assigned-locations-info.component.html',
  styleUrls: ['./assigned-locations-info.component.less'],
  imports: [IconComponent, RtTooltip, TranslatePipe, FnCallPipe, BadgeComponent, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.display-inline]': 'displayInline()',
  },
})
export class AssignedLocationsInfoComponent {
  public showIcon = input(false);
  public displayInline = input(false);
  public tooltipPrefix = input('');
  public tooltipPosition = input<TooltipPosition>('below');
  public locationNames = input<string[]>([]);
  public isBadge = input(false);

  public isTruncatedFactory = (elRef: HTMLElement) => () => elRef.offsetWidth < elRef.scrollWidth;
}
